import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../../provider/AuthProvider';
import { ROUTE_NAMES } from '../../../routes/routeConstants';

const OnboardingRedirect: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (user) {
      // First check if email is verified
      if (!user.isEmailVerified) {
        navigate(ROUTE_NAMES.PAGES.VERIFY_EMAIL);
        return;
      }

      // Only redirect to onboarding if user is not already on onboarding pages
      const isOnOnboardingPage = location.pathname.includes('/employee-onboarding') ||
                                 location.pathname.includes('/employer-onboarding');

      // Only check onboarding if email is verified and not on onboarding pages
      if (!isOnOnboardingPage && !user.onboardingCompleted) {
        // Redirect based on user role
        if (user.role === 'employee') {
          navigate(ROUTE_NAMES.PAGES.EMPLOYEE_ONBOARDING);
        } else if (user.role === 'employer') {
          navigate(ROUTE_NAMES.PAGES.EMPLOYER_ONBOARDING);
        }
      } else if (!isOnOnboardingPage && !user.profileCompleted) {
        // Redirect based on user role
        if (user.role === 'employee') {
          navigate(ROUTE_NAMES.PAGES.EMPLOYEE_ONBOARDING);
        } else if (user.role === 'employer') {
          navigate(ROUTE_NAMES.PAGES.EMPLOYER_ONBOARDING);
        }
      }
    }
  }, [user, navigate, location.pathname]);

  return null;
};

export default OnboardingRedirect;
